import { createSelector } from 'reselect'

import { RootState } from '@/store/Reducer'

export const selectSuppliersManagement = (state: RootState) => state.suppliersManagement

export const selectSuppliersManagementSuppliers = createSelector(
  selectSuppliersManagement,
  suppliersManagement => suppliersManagement.suppliers,
)

export const selectSuppliersManagementCountrySites = createSelector(
  selectSuppliersManagement,
  suppliersManagement => suppliersManagement.countrySites ?? [],
)

export const selectSuppliersManagementFilters = createSelector(
  selectSuppliersManagement,
  suppliersManagement => suppliersManagement.filters,
)

export const selectSuppliersManagementIsLoading = createSelector(
  selectSuppliersManagement,
  suppliersManagement => suppliersManagement.isLoading,
)

export const selectSuppliersManagementError = createSelector(
  selectSuppliersManagement,
  suppliersManagement => suppliersManagement.error,
)

export const selectSuppliersManagementCreateStatuses = createSelector(
  selectSuppliersManagement,
  suppliersManagement => suppliersManagement.createStatuses,
)
